module.exports = __webpack_public_path__ + "static/img/search.01ac9ff5.png";